// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialMediaForm_root__Vxe5n"};